import React from 'react'


import flutterStudiosLogo from '../assets/graphicDecor1.webp';
import coreGamingPannelLogo from '../assets/panelInfo3.webp';



const WelcomePage = () => {
  return (
    <div className='welcomePage'>
        <div className='welcomePageFlexContainer'>
        <img src={coreGamingPannelLogo} className="welcomPageLogos" alt="core gaming pannel logo"/>
          <div className='welcomePageText'>
            <p>Core Gaming is a leading developer of HTML5 games specifically produced to give the very best user experience possible on desktop and all of the most popular mobile devices, operating systems and current browsers.</p>
            <p>Utilising their vast industry knowledge and expertise in multiple platform integration and deployment, they have created an efficient, flexible and adaptable HTML5 framework designed to keep them at the forefront of gaming development technology for many years to come.</p>
          </div>
            
            <img src={flutterStudiosLogo} className="welcomPageLogos" alt="core gaming pannel logo"/>
        </div>

    </div>
  )
}

export default WelcomePage